/* Refine Noor's existing sticky control; keep one native product form. */
(function(){
 'use strict';
 var sticky=document.querySelector('sticky-buy-button');if(!sticky)return;
 var pending=false;
 function update(){pending=false;if(document.hidden)return;
   var focused=document.activeElement,typing=focused&&focused.matches('input,textarea,select,[contenteditable="true"]');
   var overlay=document.querySelector('dialog[open],.side-drawer.show,#coria-box[aria-hidden="false"],.cbs-cart.is-on,.cbs-holo.is-on');
   var keyboard=window.visualViewport&&window.innerHeight-window.visualViewport.height>150;
   var hidden=!!(overlay||typing||keyboard);
   if(sticky.classList.contains('cc-sticky-paused')!==hidden)sticky.classList.toggle('cc-sticky-paused',hidden);
   sticky.inert=hidden||sticky.classList.contains('fade-out')||sticky.classList.contains('hidden');
   var dock=document.querySelector('.cf-dock');var offset=dock&&getComputedStyle(dock).display!=='none'?Math.ceil(dock.getBoundingClientRect().height)+22:12;
   var value=offset+'px';if(sticky.style.getPropertyValue('--cc-sticky-bottom')!==value)sticky.style.setProperty('--cc-sticky-bottom',value);
 }
 function schedule(){if(!pending){pending=true;requestAnimationFrame(update);}}
 document.addEventListener('click',function(e){var b=e.target.closest('[data-sticky-buy-button]');if(!b)return;var f=b.form,original=f&&f.querySelector('[name="add"]');
   if(!f||!original||original===b)return;e.preventDefault();e.stopImmediatePropagation();
   var variant=f.querySelector('[name="id"]');
   if(original.disabled||!variant||variant.disabled||!f.reportValidity()){
     f.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});original.focus();return;
   }
   original.click();
 },true);
 window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);document.addEventListener('focusin',schedule);document.addEventListener('focusout',schedule);
 document.addEventListener('coria:chat-opened',schedule);document.addEventListener('coria:chat-closed',schedule);
 if(window.visualViewport)window.visualViewport.addEventListener('resize',schedule);
 new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['class','aria-hidden','open'],subtree:true,childList:true});
 update();
})();
